/*
 * @Author: Chao Yang
 * @Date: 2019-12-11 09:49:33
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-12 08:30:49
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Document from 'src/app/domain/model/document';
import * as Fund from 'src/app/domain/model/fund';
import { BaseProxy } from '../base.proxy';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class FundProxy extends BaseProxy {
  getFunds(
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IFund[]> {
    return this._http.post<Document.IFund[]>('/ip/api/fund', accounts);
  }

  getFundsAll(
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IFund[]> {
    return this._http.post<Document.IFund[]>('/ip/api/fund/all', accounts);
  }

  getOfferings(type: number): Observable<Fund.IFund[]> {
    return this._http.get<Fund.IFund[]>('/ip/api/fund/marketing/' + type);
  }

  read(fundId: number): Observable<void> {
    return this._http.post<void>(
      '/ip/api/fund/' + fundId + '/marketing/read',
      undefined
    );
  }

  interesetedInFund(fundId: number) {
    return this._http.post<void>(
      '/ip/api/fund/' + fundId + '/marketing/interested',
      undefined
    );
  }

  getFundDescription(fundId: number) {
    return this._http.get<string>(`/ip/api/fund/${fundId}/description`);
  }
}
